export class DsgStorageTierFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<DsgStorageTier>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<DsgStorageTier>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DsgStorageTierFilters.attributeTypeMap;
    }
    constructor() {
    }
}
